/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { Tooltip as ReactTooltip } from 'react-tooltip';

import {
  ClosesIcon,
  Excel,
  Filter,
  Pdf,
  Printer,
  Search
} from "../EntryFile/imagePath";

const Tabletop = ({ inputfilter, togglefilter, handleSelectedItemChange, handleEliminarMultiplos, generatePDF, generateExcel, setNomeFilter, handleFilterSubmit, logoTipo, tableHeader, tableData, ficheiroNome }) => {

  return (
    <div className="table-top">
      <div className="search-set">
        <div className="search-path">
          <a
            className={` btn ${inputfilter ? "btn-filter setclose" : "btn-filter"
              } `}
            id="filter_search"
            onClick={() => togglefilter(!inputfilter)}
          >
            <img src={Filter} alt="img" />
            <span>
              <img src={ClosesIcon} alt="img" />
            </span>
          </a>
        </div>
        <div className="search-input">
          <input 
            className="form-control form-control-sm search-icon"
            type="search"
            placeholder="Procurar..."
            onChange={(e) => setNomeFilter(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleFilterSubmit()
              }
            }}
          />
          <Link to="#" className="btn btn-searchset">
            <img src={Search} alt="img" />
          </Link>
        </div>
      </div>
      <div className="wordset">
        <ul>
          <ReactTooltip place="top" type="dark" effect="solid" />
          <li title="Eliminar registos selecionados">
            <a data-tip="toggle" onClick={() => handleEliminarMultiplos()}>
              <i className="fa fa-trash"></i>
            </a>
          </li>
          <li title="Desativar registos selecionados">
            <a data-tip="toggle" onClick={() => handleSelectedItemChange(0)}>
              <i className="fa fa-toggle-off text-danger"></i>
            </a>
          </li>
          <li title="Ativar registos selecionados">
            <a data-tip="toggle" onClick={() => handleSelectedItemChange(1)}>
              <i className="fa fa-toggle-on text-success"></i>
            </a>
          </li>

          <li title="Exportar em PDF">
            <a data-tip="Pdf" onClick={() => generatePDF(logoTipo,tableData,tableHeader,ficheiroNome)}>
              <img src={Pdf} alt="img" />
            </a>
          </li>

          <li title="Exportar em Excel">
            <a data-tip="Excel" onClick={() => generateExcel(tableData, tableHeader, ficheiroNome)}>
              <img src={Excel} alt="img" />
            </a>
          </li>
          {/* <li title="Imprimir">
            <a data-tip="Print">
              <img src={Printer} alt="img" />
            </a>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

export default Tabletop;
